<script lang="ts">
  import NotchedSlider from '../ui/NotchedSlider.svelte';
  import Select from '../ui/Select.svelte';
  import { BOARD_SIZES, MIN_WORD_LENGTH, ROUND_DURATIONS, type GameConfig } from '../../shared/config';
  import { DIFFICULTY_PRESETS } from '../content/difficulty';

  /** Board, difficulty, round time and word length rows; the parent supplies the settings grid. */
  interface Props {
    config: GameConfig;
    editable: boolean;
    change: (patch: Partial<GameConfig>) => void;
    /** What `roundDuration` times in this mode: Endless times each board, not the round. */
    durationLabel?: 'Round Time' | 'Board Time';
  }
  let { config, editable, change, durationLabel = 'Round Time' }: Props = $props();

  /** Players pick a minimum word length between the dictionary floor and a playable ceiling. */
  const MAX_SELECTABLE_MIN_WORD_LENGTH = 7;
  const MIN_WORD_LENGTHS = Array.from(
    { length: MAX_SELECTABLE_MIN_WORD_LENGTH - MIN_WORD_LENGTH + 1 },
    (_, i) => ({ value: MIN_WORD_LENGTH + i, label: `${MIN_WORD_LENGTH + i}` }),
  );
  const ROUND_LENGTHS = ROUND_DURATIONS.map((value) => ({ value, label: `${value}s` }));
</script>

<label for="board-size">Board</label>
<Select
  id="board-size"
  aria-label="board size"
  value={config.boardSize}
  disabled={!editable}
  onchange={(value) => change({ boardSize: value })}
  options={BOARD_SIZES.map((value) => ({ value, label: `${value} × ${value}` }))}
/>
<label for="board-difficulty">Difficulty</label>
<NotchedSlider
  id="board-difficulty"
  aria-label="board difficulty"
  value={config.difficulty}
  disabled={!editable}
  onchange={(value) => change({ difficulty: value })}
  options={DIFFICULTY_PRESETS}
/>
<label for="round-length">{durationLabel}</label>
<NotchedSlider
  id="round-length"
  aria-label={durationLabel.toLowerCase()}
  value={config.roundDuration}
  disabled={!editable}
  onchange={(value) => change({ roundDuration: value })}
  options={ROUND_LENGTHS}
/>
<label for="min-word-length">Word Length</label>
<NotchedSlider
  id="min-word-length"
  aria-label="word length"
  value={config.minWordLength}
  disabled={!editable}
  onchange={(value) => change({ minWordLength: value })}
  options={MIN_WORD_LENGTHS}
/>
